module.exports = __webpack_public_path__ + "assets/img/9cd8ea3f9a4434eb39e031f30eb98115.png";